import { useQuery } from '@tanstack/react-query'
import { useResellerContext } from '../useResellerContext'
import { QUERY_DATA } from 'src/service'
import { getProductsOnSale } from 'src/service/productsOnSaleService'

class ProductsOnSaleError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ProductsOnSaleError'
  }
}

export const useProductsOnSale = () => {
  const resellerContext = useResellerContext()
  const { data, isLoading } = useQuery(
    [QUERY_DATA.ON_SALE],
    async () => {
      const productsOnSale = await getProductsOnSale({
        reseller: resellerContext?.reseller,
        pagination: { page_size: 12, page: 1 },
        isGenericReseller: Boolean(resellerContext?.isGenericUser),
      })

      return productsOnSale.data.products
    },
    {
      refetchOnWindowFocus: false,
      onError: () => {
        window.NREUM.noticeError(new ProductsOnSaleError('Failed to fetch products on sale.'), {
          origin: 'MLD/Home',
          brand: process.env.REACT_APP_CURRENT_BRAND,
          params: {
            resellerContext,
          },
        })
      },
    },
  )

  return {
    isLoading,
    data,
  }
}
